module.exports = "<div class=\"snackbar\" [@snack-visibility]=\"snackVisibility\">\r\n    {{message}}\r\n</div>\r\n"